const fileUpload = () => {
  const fileInputs = document.querySelectorAll(
    ".contact-form input[type='file']",
  )

  fileInputs &&
    fileInputs.forEach((elm) => {
      elm.addEventListener('change', function () {
        if (elm.files.length > 0) {
          elm.classList.add('gf-file-uploaded')
        } else {
          elm.classList.remove('gf-file-uploaded')
        }
      })
    })
}

export default fileUpload
